export enum TerranisService {
    WAGO = "wago",
    OENOVIEW = "oenoview"
}